<template lang="pug">
  div(:class="b({ iconized: item.icon ? true : false, selected })" @click="onClick")
    div(:class="b('container')")
      div(v-if="item.icon" :class="b('icon')")
        img(:src="item.icon")
      div(:class="b('body')")
        div(v-if="item.title" :class="b('title')") {{ item.title }}
        div(v-if="item.text" :class="b('text')") {{ item.text }}
      div(:class="b('check')")
        rtc-icoimage(v-show="selected" name="check-circle-blue")
    div(
      v-if="item.help"
      ref="help"
      v-html="item.help"
      :class="b('help')"
    )
</template>

<script>
  import $ from 'jquery';

  export default {
    name: 'choices-item',

    props: {
      item: { type: Object, required: true },
      selected: { type: Boolean, default: false },
    },

    methods: {
      onClick() {
        this.$emit('click', this.item);
      },

      toggleHelp() {
        $(this.$refs.help).slideToggle();
      },
    },

    watch: {
      selected() {
        if(this.item.help) this.toggleHelp();
      },
    }
  };
</script>

<style lang="sass" scoped>
  .choices-item
    cursor: pointer
    border-radius: 3px
    border: solid 1px $primaryColor
    overflow: hidden

    transition: box-shadow .2s linear

    &:hover
      box-shadow: 1px 2px 10px darken(white, 30%)

    &__container
      display: flex
      align-items: center
      padding: 14px 22px

    &__icon
      position: relative
      display: flex
      justify-content: center
      align-items: center
      width: 78px
      height: 78px
      margin-right: 16px
      border-radius: 50%
      background-color: #eff2f8

      img
        width: 60%

    &__body
      flex: 1

    &__title
      font-size: 14px
      font-weight: 500
      user-select: none

    &__check
      $size: 27px

      width: $size
      height: $size
      border-radius: 50%
      border: solid 1px $primaryColor

      img
        width: 100%
        height: 100%

    &__help
      display: none
      background-color: white
      padding: 18px 13px
      border-top: 1px solid $primaryColor

    &--selected
      border: solid 1px $primaryColor !important

      .choices-item
        &__container
          background-color: transparentize($primaryColor, 0.92)

        &__icon
          background-color: $primaryColor

        &__check
          border: none

    &--iconized
      border: none

      .choices-item
        &__title
          font-size: 16px

        &__container
          align-items: stretch

        &__body
          padding-top: 10px

        &__check
          width: 22px
          height: 22px
          border: none

        &__text
          font-size: 14px
</style>